(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/pay-lyckoplatsen/assets/javascripts/draw-date-text.js') >= 0) return;  svs.modules.push('/components/tur/pay-lyckoplatsen/assets/javascripts/draw-date-text.js');
"use strict";


const {
  fetchDrawData
} = svs.tur.pay_lyckoplatsen;
const {
  logger
} = svs.tur.pay_lyckoplatsen;
function drawDateText(_ref) {
  let {
    isSubscription = false,
    startDate,
    endDate,
    weeks = 4
  } = _ref;
  if (isSubscription) {
    return 'Totalt 3 dragningar i veckan, tisdagar, torsdagar och söndagar. Prenumerationen har ingen bindningstid och betalas månadsvis med bankkort eller autogiro.';
  }
  const formattedStartDate = dateFns.format(new Date(startDate.regCloseTime), 'd/M', {
    locale: dateFns.sv
  });
  const formattedEndDate = dateFns.format(new Date(endDate.regCloseTime), 'd/M', {
    locale: dateFns.sv
  });
  const plural = weeks > 1 ? 'ar' : '';
  return "Totalt ".concat(weeks * 3, " dragningar, tisdag").concat(plural, ", torsdag").concat(plural, " och s\xF6ndag").concat(plural, ". Start ").concat(formattedStartDate, ", avslutas ").concat(formattedEndDate, ".");
}
function drawStartEndText(_ref2) {
  let {
    startDate,
    endDate,
    weeks = 4
  } = _ref2;
  const formattedStartDate = dateFns.format(new Date(startDate.regCloseTime), 'd/M', {
    locale: dateFns.sv
  });
  const formattedEndDate = dateFns.format(new Date(endDate.regCloseTime), 'd/M', {
    locale: dateFns.sv
  });
  const plural = weeks > 1 ? 'ar' : '';
  return {
    totalText: "Totalt ".concat(weeks * 3, " dragningar, tisdag").concat(plural, ", torsdag").concat(plural, " och s\xF6ndag").concat(plural, "."),
    startEndText: "Start ".concat(formattedStartDate, ", avslutas ").concat(formattedEndDate, ".")
  };
}
async function drawDateTextAsync(_ref3) {
  let {
    isSubscription = false,
    numberOfWeeks
  } = _ref3;
  try {
    const {
      firstDraw: startDate,
      lastDraw: endDate
    } = await fetchDrawData(numberOfWeeks);
    return drawDateText({
      isSubscription,
      startDate,
      endDate
    });
  } catch (error) {
    logger.error('Failed to fetch draw data', error);
  }
}
setGlobal('svs.tur.pay_lyckoplatsen', {
  drawDateText,
  drawDateTextAsync,
  drawStartEndText
});

 })(window);